module.exports = __webpack_public_path__ + "static/img/start.4f21f38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoBg/Clocks/start.jpg
// module id = 54Vr
// module chunks = 1